export default {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 46px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 36,
    paddingBottom: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  action: {
    flex: '1 1 0',
    justifyContent: 'center',
    minHeight: 40,
    maxHeight: 40,
  },
  actionButton: {
    maxWidth: 'none',
    fontSize: 14,
  },
  head: {
    display: 'flex',
    flex: '0 0 auto',
  },
  title: {
    fontSize: 20,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    overflow: 'auto',
    justifyContent: 'space-around',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    overflow: 'auto',
    justifyContent: 'space-around',
  },
  listSection: {
    display: 'flex',
    justifyContent: 'space-around',
  },
};



// WEBPACK FOOTER //
// ./src/styles/TProfile.js